export const DEFAULT_DATE_PLACEHOLDER = "mm/dd/yyyy";
export const DEFAULT_DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
};
export const DEFAULT_WINDOW_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
	hour: "numeric",
	minute: "2-digit",
	hour12: true,
	timeZoneName: "short",
};
export const DEFAULT_ANSWER_LABEL = "YOUR VOTE";
export const DEFAULT_HELPER_LABEL = "Tap to pick a winner";
export const DEFAULT_RESULTS_HELPER_LABEL = "Results";
export const DEFAULT_PRE_VOTE_HEADER = "Voting opens in";
export const DEFAULT_SKIP_BUTTON_LABEL = "Skip";
export const DEFAULT_NEXT_BUTTON_LABEL = "Next";
export const DEFAULT_COMPLETE_BUTTON_LABEL = "View all picks";
export const DEFAULT_RESTART_BUTTON_LABEL = "Vote again";
export const DEFAULT_NEW_SERIES_NAME = "Untitled series";
